var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookLoadingAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ej5uRKs9mLC1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ej5uRKs9mLC15-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC15-filter-inner-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "4,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC15-filter-inner-shadow-0-offset",
    dx: -2,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC15-filter-inner-shadow-0-composite",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "ej5uRKs9mLC15-filter-inner-shadow-0-color-matrix",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC15-filter-inner-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC15-filter-inner-shadow-0-merge-node-1",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC15-filter-inner-shadow-0-merge-node-2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ej5uRKs9mLC28-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC28-filter-inner-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "4,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC28-filter-inner-shadow-0-offset",
    dx: -2,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC28-filter-inner-shadow-0-composite",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "ej5uRKs9mLC28-filter-inner-shadow-0-color-matrix",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC28-filter-inner-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC28-filter-inner-shadow-0-merge-node-1",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC28-filter-inner-shadow-0-merge-node-2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ej5uRKs9mLC29-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC29-filter-inner-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "10,2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC29-filter-inner-shadow-0-offset",
    dx: 0,
    dy: 1,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC29-filter-inner-shadow-0-composite",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "ej5uRKs9mLC29-filter-inner-shadow-0-color-matrix",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC29-filter-inner-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC29-filter-inner-shadow-0-merge-node-1",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC29-filter-inner-shadow-0-merge-node-2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ej5uRKs9mLC30-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC30-filter-inner-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "2,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC30-filter-inner-shadow-0-offset",
    dx: -2,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC30-filter-inner-shadow-0-composite",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "ej5uRKs9mLC30-filter-inner-shadow-0-color-matrix",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC30-filter-inner-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC30-filter-inner-shadow-0-merge-node-1",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC30-filter-inner-shadow-0-merge-node-2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ej5uRKs9mLC31-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC31-filter-inner-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "2,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC31-filter-inner-shadow-0-offset",
    dx: -2,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC31-filter-inner-shadow-0-composite",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "ej5uRKs9mLC31-filter-inner-shadow-0-color-matrix",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC31-filter-inner-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC31-filter-inner-shadow-0-merge-node-1",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC31-filter-inner-shadow-0-merge-node-2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ej5uRKs9mLC32-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "2,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-0-offset",
    dx: -2,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-0-composite",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-0-color-matrix",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-0-merge-node-1",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-0-merge-node-2"
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-1-blur",
    in: "result",
    stdDeviation: "0,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-1-offset",
    dx: 0,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-1-composite",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-1-color-matrix",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-1-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-1-merge-node-1",
    in: "result"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC32-filter-inner-shadow-1-merge-node-2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ej5uRKs9mLC33-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "ej5uRKs9mLC33-filter-drop-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "1,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "ej5uRKs9mLC33-filter-drop-shadow-0-offset",
    dx: 0,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "ej5uRKs9mLC33-filter-drop-shadow-0-flood",
    floodColor: "#000"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "ej5uRKs9mLC33-filter-drop-shadow-0-composite",
    operator: "in",
    in2: "tmp"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "ej5uRKs9mLC33-filter-drop-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC33-filter-drop-shadow-0-merge-node-1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "ej5uRKs9mLC33-filter-drop-shadow-0-merge-node-2",
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.000001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.664055,93.511293L35.22668,226.199858l96.329662,2.703628c0,0,7.074284,8.590197,18.443658,8.590197s17.433047-7.579587,17.433047-7.579587l96.227458-2.660251L232.880526,92.607413l-82.880529,1.884751-85.335942-.980871Z",
    transform: "translate(.000004 0.000006)",
    fill: "#025aa0",
    stroke: "#3f5787",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.271606,3.944362.800643-135.510191-68.419701-1.383306Z",
    transform: "matrix(-1 0 0 1 298.837156 0.802689)",
    fill: "#c9ccbe",
    stroke: "#7d8171",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.271606,3.944362.800643-135.510191-68.419701-1.383306Z",
    transform: "matrix(-1 0 0 1 297.850829 0.217955)",
    fill: "#c9ccbe",
    stroke: "#7d8171",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.271606,3.944362.800643-135.510191-68.419701-1.383306Z",
    transform: "matrix(-1 0 0 1 296.826834-.294926)",
    fill: "#d3d6c8",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.271606,3.944362.653293-134.713711-68.272351-2.179786Z",
    transform: "matrix(-1 0 0 1 295.524854-.82399)",
    fill: "#d9dcce",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.317903,223.824277c0,0,66.123993,2.038627,80.564734,2.630281s16.179997,1.653845,16.179997,1.653845l.698508-134.148228c0,0-9.233369-3.422305-20.905318-4.134009s-47.412248,1.38874-47.412248,1.38874Z",
    transform: "matrix(-1 0 0 1 294.18565-1.015305)",
    fill: "#d9dcce",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L36.832071,223.884215c0,0,66.609825,1.978689,81.050566,2.570343s16.179997,1.653845,16.179997,1.653845l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 293.3938-1.279255)",
    fill: "#d9dcce",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.813375,223.822769c0,0,67.628521,2.040135,82.069262,2.631789s16.179997,1.653845,16.179997,1.653845l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 291.905902-1.549782)",
    fill: "#e3e6d8",
    stroke: "#c0c5b1",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.750375,223.758861c0,0,68.500112,1.573818,82.940853,2.165472s15.371406,2.18407,15.371406,2.18407l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 291.014032-1.857933)",
    fill: "#e3e6d8",
    stroke: "#c0c5b1",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.750375,223.758861c0,0,69.556117,1.078205,83.996858,1.669859s14.315401,2.679683,14.315401,2.679683l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 289.591576-1.756432)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.750375,223.758861c0,0,69.352497.135027,83.793238.726681s14.519021,3.622861,14.519021,3.622861l.891024-133.374516c0,0-8.605201-6.480056-20.089459-6.627921s-48.420623,3.10894-48.420623,3.10894Z",
    transform: "matrix(-1 0 0 1 288.119544-1.948436)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.927991,90.900907c-15.326505,66.185787-29.63661,130.425541-30.810976,132.160692c0,0,69.105734-.159562,83.546475.432092s14.962243,4.464327,14.962243,4.464327l.392356-131.863608c0,0-8.669632-7.840579-20.15389-7.988444s-47.936208,2.794941-47.936208,2.794941Z",
    transform: "matrix(-1 0 0 1 287.142945-1.978042)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.927991,90.900907c-15.326505,66.185787-26.776834,128.63856-27.9512,130.373711c0,0,66.245958,1.627419,80.686699,2.219073s17.324585,2.510898,17.324585,2.510898l.405812-130.867828c0,0-9.955088-10.098935-21.439346-10.2468s-49.02655,6.010946-49.02655,6.010946Z",
    transform: "matrix(-1 0 0 1 287.785277 0.142502)",
    filter: "url(#ej5uRKs9mLC15-filter)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.927991,90.900907c-15.326505,66.185787-26.776834,128.63856-27.9512,130.373711c0,0,66.245958,1.627419,80.686699,2.219073s17.406529,4.083277,17.406529,4.083277l-.0213-131.632573c0,0-13.021355-9.279021-24.505613-9.426886s-45.615115,4.383398-45.615115,4.383398Z",
    transform: "translate(11.140639-1.634478)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 233.56235 4.641228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.730667,3.601612.341582-135.167441-68.419701-1.383306Z",
    transform: "matrix(-1 0 0 1 233.884766-4.138801)",
    fill: "#c9ccbe",
    stroke: "#7d8171",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.271606,3.944362.800643-135.510191-68.419701-1.383306Z",
    transform: "matrix(-1 0 0 1 232.898439-4.723535)",
    fill: "#c9ccbe",
    stroke: "#7d8171",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.271606,3.944362.800643-135.510191-68.419701-1.383306Z",
    transform: "matrix(-1 0 0 1 231.874444-5.236416)",
    fill: "#d3d6c8",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.791028,224.164041l96.271606,3.944362.653293-134.713711-68.272351-2.179786Z",
    transform: "matrix(-1 0 0 1 230.572464-5.76548)",
    fill: "#d9dcce",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L37.317903,223.824277c0,0,66.123993,2.038627,80.564734,2.630281s16.179997,1.653845,16.179997,1.653845l.698508-134.148228c0,0-9.233369-3.422305-20.905318-4.134009s-47.412248,1.38874-47.412248,1.38874Z",
    transform: "matrix(-1 0 0 1 229.23326-5.956795)",
    fill: "#d9dcce",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L36.832071,223.884215c0,0,66.609825,1.978689,81.050566,2.570343s16.179997,1.653845,16.179997,1.653845l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 228.44141-6.220745)",
    fill: "#d9dcce",
    stroke: "#9fa391",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.813375,223.822769c0,0,67.628521,2.040135,82.069262,2.631789s16.179997,1.653845,16.179997,1.653845l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 226.953512-6.491272)",
    fill: "#e3e6d8",
    stroke: "#c0c5b1",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.750375,223.758861c0,0,68.500112,1.573818,82.940853,2.165472s15.371406,2.18407,15.371406,2.18407l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 226.101642-6.639423)",
    fill: "#e3e6d8",
    stroke: "#c0c5b1",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.750375,223.758861c0,0,69.556117,1.078205,83.996858,1.669859s14.315401,2.679683,14.315401,2.679683l.891024-133.374516c0,0-9.289518-6.289999-20.816406-5.889677s-47.693676,2.370696-47.693676,2.370696Z",
    transform: "matrix(-1 0 0 1 224.639186-6.697922)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.443576,91.214906L35.750375,223.758861c0,0,69.352497.135027,83.793238.726681s15.202543,4.138961,15.202543,4.138961l.207502-133.890616c0,0-8.605201-6.480056-20.089459-6.627921s-48.420623,3.10894-48.420623,3.10894Z",
    transform: "matrix(-1 0 0 1 223.167154-6.889926)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "ej5uRKs9mLC28",
    d: "M63.562446,90.686542C48.235941,156.872329,33.414475,221.419864,32.240109,223.155015c0,0,72.98264-.252978,87.423381.338676s14.399144,4.614712,14.399144,4.614712l-.36097-131.079494c0,0-10.661-9.505224-22.145258-9.653089s-47.99396,3.310722-47.99396,3.310722Z",
    transform: "matrix(-1 0 0 1 219.455019-6.826929)",
    filter: "url(#ej5uRKs9mLC28-filter)",
    fill: "#f7f8f4",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.439087,229.315515c0-1.386807,8.049568-2.695652,15.297446-2.710546s15.144749,1.957381,15.144749,3.772588-4.431249,6.017826-14.888269,6.017826-15.553926-5.693061-15.553926-7.079868Z",
    transform: "translate(.025457-.44538)",
    opacity: 0.51,
    filter: "url(#ej5uRKs9mLC29-filter)",
    fill: "#001a2e",
    stroke: "#000",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ej5uRKs9mLC30",
    d: "M66.927991,90.900907C51.601486,157.086694,40.146305,220.215813,38.971939,221.950964c0,0,66.25081.951073,80.691551,1.542727s17.404244,4.311342,17.404244,4.311342l.453723-131.214787c0,0-13.026523-9.973747-24.510781-10.121612s-46.082685,4.432273-46.082685,4.432273Z",
    transform: "matrix(-1 0 0 1 286.210827-1.561263)",
    filter: "url(#ej5uRKs9mLC30-filter)",
    fill: "#ebede0",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ej5uRKs9mLC31",
    d: "M66.927991,90.900907C51.601486,157.086694,40.146305,220.215813,38.971939,221.950964c0,0,66.25081.951073,80.691551,1.542727s17.404244,4.311342,17.404244,4.311342l.453723-131.214787c0,0-13.026523-9.973747-24.510781-10.121612s-46.082685,4.432273-46.082685,4.432273Z",
    transform: "matrix(-1 0 0 1 286.031683-1.625669)",
    filter: "url(#ej5uRKs9mLC31-filter)",
    fill: "#868780",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "ej5uRKs9mLC32",
    d: "M60.865241,222.285803c20.668699.330708,49.797434.839114,58.798249,1.207888c14.44074.591659,17.404244,4.311342,17.404244,4.311342l.453723-131.214787c0,0-13.026523-9.973747-24.510781-10.121612s-46.082685,4.432273-46.082685,4.432273C51.601486,157.086694,40.146305,220.215813,38.971939,221.950964",
    transform: "matrix(-1 0 0 1 285.514808-1.963182)",
    filter: "url(#ej5uRKs9mLC32-filter)",
    fill: "#f7f8f4",
    stroke: "#cfd5bf",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.719178,227.981716c0,0,6.775274-2.384855,14.436935-2.545763s15.681292,3.32975,15.681292,3.32975",
    transform: "translate(-.04698 0.000001)",
    opacity: 0.99,
    filter: "url(#ej5uRKs9mLC33-filter)",
    fill: "none",
    stroke: "#504f29",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookLoadingAnimation);
export default __webpack_public_path__ + "static/media/book-loading-animation.9d127e4a462ae021b9bc2ed29772d38d.svg";
export { ForwardRef as ReactComponent };